import {post,get} from '../libs/ajax.js'

export default {
    // 获取重抓数据列表
    getDataList: (data, options) => {
        return get('/retry/get_list', data, options)
    },
    getRetrySearchList(data,options){
        return post('/retry/get_search_list', data, options)
    },
    // 重抓数据-添加任务 /retry/add
    addRetryTask(data,options){
        return post('/retry/add', data, options)
    },
    // retry/status/list
    getRetryStatus(data,options){
        return get('/retry/status/list', data, options)
    },
}
